import { Component } from 'preact';
import { Router } from 'preact-router';

import Item from './item';
import Redirect from './redirect';

export default class App extends Component {
	
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Router onChange={this.handleRoute}>
					<Redirect path="/" to="/fi" />
					<Item path="/:lang/" id="" />
					<Item path="/:lang/:id" />
				</Router>
			</div>
		);
	}
}
